"use client";

import { useTranslations } from "next-intl";

import {
	Accordion,
	AccordionItemWrapper,
	AccordionTrigger,
	AccordionContent,
} from "@/ui/components/ui/accordion";

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export function StackFaq() {
	const t = useTranslations("stackBuilder");

	const items = [
		{ id: "faq-1", question: t("faq.q1"), answer: t("faq.a1") },
		{ id: "faq-2", question: t("faq.q2"), answer: t("faq.a2") },
		{ id: "faq-3", question: t("faq.q3"), answer: t("faq.a3") },
	];

	return (
		<section aria-labelledby="stack-faq-heading">
			<h2 id="stack-faq-heading" className="mb-4 text-base font-semibold text-foreground">
				{t("faq.sectionTitle")}
			</h2>

			<Accordion type="single" className="divide-y divide-border rounded-lg border border-border">
				{items.map(({ id, question, answer }) => (
					<AccordionItemWrapper key={id} value={id} className="border-b-0 px-4 last:border-b-0">
						<AccordionTrigger>
							<h3 className="text-left text-sm font-medium text-foreground">{question}</h3>
						</AccordionTrigger>
						<AccordionContent>
							<p className="text-sm leading-relaxed text-muted-foreground">{answer}</p>
						</AccordionContent>
					</AccordionItemWrapper>
				))}
			</Accordion>
		</section>
	);
}
